import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import GetScouted from "@/pages/GetScouted";
import FreeShoot from "@/pages/FreeShoot";
import RequireAuth from "@/components/RequireAuth";

function App() {
  return (
    <ReactLenis root options={{ duration: 1.2, smoothWheel: true, allowNestedScroll: true }}>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/get-scouted" element={<GetScouted />} />
          <Route path="/getscouted" element={<GetScouted />} />
          <Route path="/apply" element={<GetScouted />} />
          <Route path="/free-shoot" element={<FreeShoot />} />
          <Route path="/freeshoot" element={<FreeShoot />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <Admin />
              </RequireAuth>
            }
          />
          <Route path="/legal" element={<Legal />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
    </ReactLenis>
  );
}

export default App;
